import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <section className="min-h-screen flex items-center justify-center bg-[#faf7f2] px-6">
      <div className="max-w-3xl text-center">
        {/* 404 Text */}
        <h1 className="text-8xl font-bold text-blue-700 mb-6">404</h1>

        <h2 className="text-3xl font-semibold text-gray-800 mb-4">
          Page Not Found
        </h2>

        <p className="text-gray-600 text-lg mb-10">
          The page you are looking for might have been removed, renamed, or
          temporarily unavailable.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate("/")}
            className="px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-800 transition duration-300 shadow-md"
          >
            Go to Home
          </button>

          <button
            onClick={() => navigate("/login")}
            className="px-8 py-3 border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-600 hover:text-white transition duration-300 shadow-md"
          >
            Go to Login
          </button>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
